import { InjectionToken } from '@angular/core';
import { IMenuConfig } from './menu-config.model';

export const MenuConfig: InjectionToken<IMenuConfig> = new InjectionToken('MenuConfig');




// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/menu/models/menuConfig.ts